import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControlPipe } from "@bequeathed/ngx-utils";
import { validatePostcode } from "../../../validators/postcode.validator";
import { BaseInputControl } from '../base-input-control/base-input-control.component';
import { KeyValuePipe, NgClass } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";

/**
 * Display a control which actively validates post code input
 *
 * @author Mateusz Jablonski
 */
@Component({
    selector: 'postcode-control',
    templateUrl: '../text-control/text-control.component.html',
    styleUrls: [
        '../base-input-control/base-input-control.component.sass',
        '../../base-form/base-form.component.sass'
    ],
    imports: [
        // Angular
        NgClass,
        ReactiveFormsModule,
        // Bequeathed
        FormControlPipe,
        KeyValuePipe
    ],
    standalone: true,
    encapsulation: ViewEncapsulation.None
})
export class PostcodeControl extends BaseInputControl implements OnInit {

    constructor() {
        super();
        this.inputType = 'text';
    }

    override ngOnInit(): void {
        this.addPostCodeValidation();
        super.ngOnInit();

        if (this.editingResponse) {
            this.setPreviousResponse()
        }
    }

    private addPostCodeValidation(): void {
        if (this.question.type === 'POSTCODE') {
            this.validators.push(validatePostcode());
        }
    }
}
